import {
    getBillingCodeOdooLoading,
    getBillingCodeOdooRequest,
    getBillingCodeOdooSuccess,
    getBillingCodeOdooReject,
} from "../../actions/billingCode/getOdooProducts";

export const getBillingCodeOdoo = (formData) => async (dispatch, getState) => {
    dispatch(getBillingCodeOdooLoading());
    try {
        const { data } = await getBillingCodeOdooRequest(formData, getState);
        dispatch(getBillingCodeOdooSuccess(data))
    } catch (error) {
        dispatch(getBillingCodeOdooReject(error))
    }
    return Promise.resolve();
};
